

<div class="flex flex-wrap h-full sm:h-full md:h-full lg:h-screen xl:h-screen">
  <div *ngIf="isMapVisible" class="absolute bottom-5 left-0 z-50">
    <button (click)="toggleMap()"
    class="bg-primary block sm:inline-block text-white font-bold text-sm sm:text-xs px-1 py-1 sm:px-2 sm:py-2 rounded animate__animated animate__fadeInTopRight animate__delay-1s">
    Volver
  </button>

</div>

<div class="flex flex-wrap h-full w-full sm:h-full md:h-full lg:h-screen xl:h-screen">

  <!-- Home Content -->
 <div  class="w-full md:w-6/12 relative flex flex-col items-center justify-center p-4">
  <app-access-home [services]="services"></app-access-home>
 </div>


  <!-- Map -->
  <div *ngIf="isMapVisible || !isSmallScreen"
  class="h-full w-full md:w-6/12 relative animate__animated animate__fadeInTopRight animated__delay-1s"
  [ngClass]="{ 'h-screen': isSmallScreen, 'md:w-6/12': !isSmallScreen }">
  <app-map [coordinates]="coordinates" (assistantSchedule)="($event)"></app-map>
</div>

<div *ngIf="!isMapVisible" class="w-full grid grid-cols-1 md:grid-cols-3 gap-6 p-8 bg-gradient-to-r mt-7 from-azulOscuro via-primary to-azulOscuro text-black">
   <!-- Logo y descripción -->
  <div class="space-y-4">
    <img src="../../../assets/images/logo-23.png" alt="logo" class="w-40 cursor-pointer animate__animated animate__zoomInDown animate__delay-1s">
    <p class="text-gray-300">
      Pitzon es una plataforma innovadora diseñada para conectar personas y servicios de manera eficiente. 🌟 Con un enfoque en la calidad y la experiencia del usuario, ofrece soluciones prácticas y personalizadas. 🚀 Desde gestión de tareas hasta soporte técnico, Pitzon simplifica tu día a día. Únete y descubre cómo transformar tus proyectos con tecnología de vanguardia. 🌐
    </p>
  </div>

  <!-- Respaldados por -->
  <div class="space-y-4">
    <h2 class="text-lg font-semibold text-gray-100">Respaldados por</h2>
    <div class="flex items-center space-x-4">
      <img src="https://tuulapp.com/assets/images/footer/brands/innocar.png" alt="innocar" class="w-28 h-28 object-contain cursor-pointer hover:scale-105 transition-transform">
      <img src="https://tuulapp.com/assets/images/home/logo.png" alt="logo" class="w-28 h-28 object-contain cursor-pointer hover:scale-105 transition-transform">
    </div>
  </div>

  <!-- Redes sociales -->
  <div class="space-y-4">
    <h2 class="text-lg font-semibold text-gray-100">Síguenos</h2>
    <app-networks></app-networks>
  </div>
</div>
</div>
